export default [
  {
    path: '/active-fdzt/index',
    name: 'index',
    component: () => import('@/views/active-fdzt/index'),
    meta: {
      title: '复读生必看！哪所复读学校适合你？'
    }
  },
  {
    path: '/active-fdzt/detail',
    name: 'detail',
    component: () => import('@/views/active-fdzt/detail'),
    meta: {
      title: '复读生必看！哪所复读学校适合你？'
    }
  },
]
